import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

export interface School {
  id: string
  name: string
  district?: {
    id: string
    name: string
  }
  city?: {
    id: string
    name: string
  }
}

const API_URL =
  import.meta.env.VITE_EPC_API_URL ?? import.meta.env.REACT_APP_API_URL ?? ''

const getSchools: QueryFunction<
  School[],
  ['schools', { district: string | undefined }]
> = async ({ queryKey }) => {
  const [_, { district }] = queryKey
  const params = new URLSearchParams(district ? { district } : {})
  const url = `${API_URL}/schools${district ? `?${params}` : ''}`

  // Use regular fetch since the existing implementation does this
  const res = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  return res.json()
}

export const useSchools = (district?: string) => {
  return useQuery({
    queryKey: ['schools', { district }] as const,
    queryFn: getSchools,
    enabled: !!district, // only run query when district is provided
  })
}
